import axios from "axios";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import Blockonomics from "../../../src/assets/images/blockonomics_black_logo.svg";
import Escrow from "../../../src/assets/images/escrow.svg";
import Logo from "../../../src/assets/images/logo192.png";
import { useStep } from "../../contexts/stepContexts";
import {
  BuyProductUrl,
  isCouponValid,
  NowPaymentsCurrenciesUrl,
  UpdateInvoiceUrl,
} from "../../utils/Routes";
import ChooseModal from "./ChooseModal";
import EscrowPayment from "./Escrow/EscrowPayment";
import Modal from "./Modal";
import NowPayments from "./NowPayments";
import Terms from "./Terms";

// NOWPayments is temporarily unavailable, so its option is hidden from the
// checkout modal. Flip this back to true to bring the option back; the rest of
// the NOWPayments flow is left untouched.
const NOWPAYMENTS_ENABLED = false;

// Add CountdownTimer component
const CountdownTimer = ({ expiryDate }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const expiry = new Date(expiryDate).getTime();
      const difference = expiry - now;

      if (difference <= 0) {
        return "Истекло";
      }

      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [expiryDate]);

  return (
    <div className="text-center bg-gray-800 p-4 rounded-lg mb-4">
      <p className="text-gray-300 text-sm mb-1">Оплата истекает через:</p>
      <p className="text-xl font-mono font-bold text-white">{timeLeft}</p>
    </div>
  );
};

// Add formatCurrencyName function at the top
const formatCurrencyName = (currency) => {
  // Special cases for common cryptocurrencies
  const specialCases = {
    btc: "Bitcoin (BTC)",
    eth: "Ethereum (ETH)",
    usdt: "Tether (USDT)",
    usdc: "USD Coin (USDC)",
    bnb: "Binance Coin (BNB)",
    xrp: "Ripple (XRP)",
    ada: "Cardano (ADA)",
    sol: "Solana (SOL)",
    dot: "Polkadot (DOT)",
    doge: "Dogecoin (DOGE)",
  };

  if (specialCases[currency?.toLowerCase()]) {
    return specialCases[currency.toLowerCase()];
  }

  // Handle suffixes
  const suffixes = ["erc20", "bsc", "arb", "matic", "mainnet", "trc20"];
  let base = currency || "";
  let suffix = "";

  for (const s of suffixes) {
    if (currency?.toLowerCase().endsWith(s)) {
      base = currency.slice(0, -s.length);
      suffix = ` (${s.toUpperCase()})`;
      break;
    }
  }

  // Capitalize the base name
  base = base.charAt(0).toUpperCase() + base.slice(1).toLowerCase();
  return base + suffix;
};

export const PriceCard = ({ details, isOffer }) => {
  const { priceAfterVoucher, setPriceAfterVoucher } = useStep();

  const [address, setAddress] = useState(null);
  const [btcRate, setBtcRate] = useState(0);
  const [loading, setLoading] = useState(false);
  const [updatedPackagePrice, setUpdatedPackagePrice] = useState(0);
  const [currencyCount, setCurrencyCount] = useState(null);
  const [availableCurrencies, setAvailableCurrencies] = useState([]);
  const [showNowPayments, setShowNowPayments] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [isNowPaymentsModalOpen, setIsNowPaymentsModalOpen] = useState(false);

  useEffect(() => {
    if (address) {
      const ws = new WebSocket(`wss://www.blockonomics.co/payment/${address}`);

      ws.onopen = function () {
        console.log("");
      };

      ws.onmessage = async function (event) {
        const txs = JSON.parse(event.data);

        if (txs) {
          let status;
          if (txs.status === -1) {
            status = "PAYMENT_ERROR";
          } else if (txs.status === 0) {
            status = "Unconfirmed";
          } else if (txs.status === 1) {
            status = "Partially Confirmed";
          } else if (txs.status === 2) {
            status = "Confirmed";
          }

          try {
            await axios.patch(UpdateInvoiceUrl + `/${address}`, {
              trx_id: txs.txid,
              status,
              paid_amount: txs.value,
              address: address,
            });

            window.location.reload();
          } catch (error) {
            console.error(error);
          }
        }
      };

      ws.onclose = function () {
        console.log("");
      };

      return () => {
        ws.close();
      };
    }
  }, [address]);

  useEffect(() => {
    const fetchCurrencyCount = async () => {
      try {
        const response = await axios.get(NowPaymentsCurrenciesUrl);
        if (
          response.data &&
          response.data.data &&
          Array.isArray(response.data.data.currencies)
        ) {
          setCurrencyCount(response.data.data.currencies.length);
          setAvailableCurrencies(response.data.data.currencies.slice(0, 3));
        }
      } catch (error) {
        setCurrencyCount(null);
      }
    };
    fetchCurrencyCount();
  }, []);

  const [showCouponInput, setShowCouponInput] = useState(true);
  const navigate = useNavigate();
  const [showModal, setShowModal] = React.useState(false);
  const [termsAccepted, setTermAccepted] = React.useState(false);
  const [couponCode, setCouponCode] = React.useState("");
  const [couponCodeError, setCouponCodeError] = React.useState("");

  const handleUserLogging = () => {
    let user = localStorage.getItem("user");
    if (user !== null) {
      setShowModal(true);
    } else {
      navigate("/login");
    }
  };

  const handlePayment = async () => {
    console.log("handlePayment called");
    let user = localStorage.getItem("user");

    if (user != null) {
      let userInfo = JSON.parse(user);

      try {
        const response = await axios.post(BuyProductUrl, {
          price: details?.price,
          coupon: couponCode,
          product_name: details?.title,
          email: userInfo.email,
        });

        setAddress(response?.data?.newAddressData?.address);
        setBtcRate(response?.data?.price_in_btc);
        setUpdatedPackagePrice(response?.data?.price);
        closeModal_package();
        openModal();
      } catch (error) {
        console.error("Payment error:", error);
        alert(`Ошибка платежа: ${error.message}`);
      }
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen_package, setIsModalOpen_package] = useState(false);
  const [checkedValue, setCheckedValue] = useState("");
  const [showWindow, setShowWindow] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openModal_package = () => setIsModalOpen_package(true);
  const closeModal_package = () => setIsModalOpen_package(false);
  const openWindow = () => setShowWindow(true);
  const closeWindow = () => setShowWindow(false);
  const openNowPaymentsModal = () => setIsNowPaymentsModalOpen(true);
  const closeNowPaymentsModal = () => setIsNowPaymentsModalOpen(false);

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      setCheckedValue(event.target.value);
    } else {
      setCheckedValue("");
    }
  };

  const handleContinue = async () => {
    setLoading(true);

    if (checkedValue === "blockonomics") {
      let user = localStorage.getItem("user");

      if (user != null) {
        let userInfo = JSON.parse(user);

        try {
          const response = await axios.post(BuyProductUrl, {
            price: priceAfterVoucher,
            coupon: couponCode,
            product_name: details?.title,
            email: userInfo.email,
          });

          setAddress(response?.data?.newAddressData?.address);
          setBtcRate(response?.data?.price_in_btc);
          setUpdatedPackagePrice(response?.data?.price);
          closeModal_package();
          openModal();
          setLoading(false);
        } catch (error) {
          console.error(error);
          setLoading(false);
        }
      }
    } else if (checkedValue === "escrow") {
      closeModal_package();
      openWindow();
    } else if (checkedValue === "nowpayments") {
      console.log("NOWPayments selected");
      closeModal_package();
      setShowNowPayments(true);
      setLoading(false);
    }
  };

  const handleAccept = async () => {
    if (couponCode) {
      try {
        const response = await axios.post(isCouponValid, {
          coupon: couponCode,
          price: details?.price,
        });

        if (response.data.isCouponValid) {
          setPriceAfterVoucher(response.data.price);
          setCouponCodeError("");
          openModal_package();
          setShowModal(false);
        } else {
          setCouponCodeError("Купон недействителен!");
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      setPriceAfterVoucher(details?.price);
      openModal_package();
      setShowModal(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "waiting":
        return "text-yellow-400";
      case "confirming":
        return "text-blue-400";
      case "confirmed":
        return "text-blue-500";
      case "sending":
        return "text-blue-600";
      case "finished":
        return "text-green-500";
      case "failed":
      case "expired":
        return "text-red-500";
      default:
        return "text-gray-400";
    }
  };

  const getStatusMessage = (status) => {
    switch (status) {
      case "waiting":
        return "Ожидание платежа";
      case "confirming":
        return "Платеж обнаружен, ожидание подтверждения";
      case "confirmed":
        return "Платеж подтвержден";
      case "sending":
        return "Обработка платежа";
      case "finished":
        return "Платеж успешно завершен";
      case "failed":
        return "Платеж не удался";
      case "expired":
        return "Платеж истек";
      default:
        return "Неизвестный статус";
    }
  };

  useEffect(() => {
    console.log("[PriceCard] isNowPaymentsModalOpen:", isNowPaymentsModalOpen);
    console.log("[PriceCard] paymentDetails:", paymentDetails);
  }, [isNowPaymentsModalOpen, paymentDetails]);

  return (
    <div>
      <div
        className={`${
          showModal ? "flex" : "hidden"
        } bg-[#0000003c] overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full justify-center items-center`}
      >
        <div className="relative p-4 w-full max-w-2xl h-full md:h-auto">
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Условия и положения
              </h3>
              <button
                onClick={() => {
                  setShowModal(false);
                }}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-toggle="defaultModal"
              >
                <svg
                  aria-hidden="true"
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="sr-only">Закрыть модальное окно</span>
              </button>
            </div>

            <div className="p-6 space-y-6">
              <Terms />

              {showCouponInput && (
                <input
                  className="rounded-md px-6 py-2 text-red-400 font-bold border border-gray-400"
                  id="coupon_code"
                  type="text"
                  onChange={(e) => {
                    setCouponCode(e.target.value);
                  }}
                  placeholder="Код купона — необязательно"
                />
              )}
              {couponCodeError && (
                <p className="text-red-600 text-sm font-semibold">
                  {couponCodeError}
                </p>
              )}
              <div className="flex items-center mb-4">
                <input
                  onChange={(e) => {
                    setTermAccepted(e.target.checked);
                  }}
                  id="default-checkbox"
                  type="checkbox"
                  value=""
                  className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  htmlFor="default-checkbox"
                  className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Я согласен с условиями.
                </label>
              </div>

              <button
                onClick={handleAccept}
                className="buy-with-crypto bg-secondary focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center text-white focus:ring-primary-900"
                disabled={!termsAccepted}
              >
                Принять
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col p-6 mx-auto max-w-lg text-center rounded-lg border shadow border-gray-600 xl:p-8 bg-gray-800 text-white">
        <h3 className="mb-4 text-2xl font-semibold">{details?.title}</h3>
        <p className="font-light sm:text-lg text-gray-400">{details.header}</p>
        {details?.tier && (
          <div className="mt-4">
            <span className="inline-block bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2 rounded-full text-lg font-bold uppercase tracking-wide shadow-lg">
              {details.tier}
            </span>
          </div>
        )}
        <div className="my-8">
          {isOffer ? (
            <div className="space-y-2">
              <div className="flex items-center justify-center gap-3">
                <div className="text-sm text-gray-400">
                  Предыдущее предложение было
                  <span className="line-through text-gray-500 ml-2">
                    ${details.offerPrice}
                  </span>
                </div>
              </div>
              <div className="flex items-center justify-center gap-2">
                <span className="text-6xl font-black tracking-tight">
                  ${details.price}
                </span>
                <span className="text-gray-400 self-end mb-2">
                  {details.lifetime ? " / lifetime" : ""}
                </span>
              </div>
              <div className="text-gray-500 text-sm">Регулярная цена</div>
            </div>
          ) : (
            <div className="flex items-baseline justify-center">
              <span className="text-xl font-bold">{details.pricePreffix}</span>
              <span className="mx-2 text-5xl font-extrabold">
                ${details.price}
              </span>
              <span className="text-gray-400">
                {details.lifetime ? " / lifetime" : ""}
              </span>
            </div>
          )}
        </div>

        <ul role="list" className="mb-8 space-y-4 text-left">
          {details.infos.map((data, index) => (
            <li key={index} className="flex items-center space-x-3">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span>{data}</span>
            </li>
          ))}
        </ul>

        <a
          onClick={handleUserLogging}
          className="buy-with-crypto cursor-pointer bg-secondary focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center text-white focus:ring-primary-900"
          href={details.checkoutUrl}
        >
          Купить за криптовалюту
        </a>

        <EscrowPayment
          openWindow={openWindow}
          closeWindow={closeWindow}
          showWindow={showWindow}
          details={details}
        />

        <div>
          <ChooseModal
            isOpen={isModalOpen_package}
            onClose={closeModal_package}
          >
            <div className="bg-[#26303C] p-4 md:p-8">
              <div className="md:flex mb-4 md:mb-8 ">
                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <img src={Logo} alt="Logo" className="" />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3
                    className="text-lg leading-6 font-medium text-white"
                    id="modal-headline"
                  >
                    {details?.title}
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-200">{details?.header}</p>
                  </div>
                </div>
              </div>

              {NOWPAYMENTS_ENABLED && (
                <div className="flex items-center mb-4 border rounded-md shadow-md hover:shadow-md hover:shadow-slate-500 transition-all duration-150">
                  <label
                    className="relative flex items-center p-4 rounded-full cursor-pointer"
                    htmlFor="nowpayments"
                  >
                    <input
                      type="checkbox"
                      className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-white checked:bg-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                      id="nowpayments"
                      value="nowpayments"
                      checked={checkedValue === "nowpayments"}
                      onChange={handleCheckboxChange}
                    />
                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 011.414 0l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                  <label
                    className="font-light text-gray-700 cursor-pointer select-none"
                    htmlFor="nowpayments"
                  >
                    <div className="flex items-center">
                      <p className="flex-1 text-white font-medium">
                        Оплатить ${priceAfterVoucher}
                      </p>
                    </div>
                  </label>
                  <label
                    className="flex-1 font-light text-gray-700 cursor-pointer select-none"
                    htmlFor="nowpayments"
                  >
                    <div className="flex items-center">
                      <p className="text-white ml-16">
                        {currencyCount && (
                          <span className="text-base text-gray-200 ml-2">
                            принимает {currencyCount} валют
                          </span>
                        )}
                      </p>
                    </div>
                  </label>
                </div>
              )}

              <div className="flex items-center mb-4 border rounded-md shadow-md hover:shadow-md hover:shadow-slate-500 transition-all duration-150">
                <label
                  className="relative flex items-center p-4 mt-1 rounded-full cursor-pointer"
                  htmlFor="blockonomics"
                >
                  <input
                    type="checkbox"
                    className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-white checked:bg-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                    id="blockonomics"
                    value="blockonomics"
                    checked={checkedValue === "blockonomics"}
                    onChange={handleCheckboxChange}
                  />
                  <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 011.414 0l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
                <label
                  className="font-light text-gray-700 cursor-pointer select-none"
                  htmlFor="blockonomics"
                >
                  <div className="flex items-center">
                    <p className="flex-1 text-white font-medium">
                      Оплатить ${priceAfterVoucher}
                    </p>
                  </div>
                </label>
                <label
                  className="flex-1 font-light text-gray-700 cursor-pointer select-none"
                  htmlFor="blockonomics"
                >
                  <div className="flex items-center">
                    <img
                      src={Blockonomics}
                      className="ml-16"
                      alt="Blockonomics"
                    />
                  </div>
                </label>
              </div>

              <div className="flex items-center mb-4 border rounded-md shadow-md hover:shadow-md hover:shadow-slate-500 transition-all duration-150">
                <label
                  className="relative flex items-center p-4 rounded-full cursor-pointer"
                  htmlFor="escrow"
                >
                  <input
                    type="checkbox"
                    className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-white checked:bg-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                    id="escrow"
                    value="escrow"
                    checked={checkedValue === "escrow"}
                    onChange={handleCheckboxChange}
                  />
                  <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 011.414 0l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
                <label
                  className="font-light text-gray-700 cursor-pointer select-none"
                  htmlFor="escrow"
                >
                  <div className="flex items-center">
                    <p className="flex-1 text-white font-medium">
                      Оплатить ${priceAfterVoucher}
                    </p>
                  </div>
                </label>
                <label
                  className="flex-1 font-light text-gray-700 cursor-pointer select-none"
                  htmlFor="escrow"
                >
                  <div className="flex items-center">
                    <img src={Escrow} className="ml-16" alt="Escrow" />
                  </div>
                </label>
              </div>

              <div className="mt-5 sm:mt-6">
                <button
                  onClick={() => handleContinue()}
                  type="button"
                  className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm ${
                    loading ? "opacity-70 cursor-not-allowed" : ""
                  }`}
                >
                  {loading ? (
                    <div className="flex space-x-3 py-1">
                      <div className="w-3 h-3 bg-gray-600 rounded-full bubble"></div>
                      <div className="w-3 h-3 bg-gray-600 rounded-full bubble"></div>
                      <div className="w-3 h-3 bg-gray-600 rounded-full bubble"></div>
                    </div>
                  ) : (
                    "Продолжить"
                  )}
                </button>
              </div>
            </div>
          </ChooseModal>

          <Modal isOpen={isModalOpen} onClose={closeModal}>
            <div className="bg-[#26303C] px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex justify-between sm:items-start">
                <div className="flex justify-between">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <img src={Logo} alt="Logo" className="" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3
                      className="text-lg leading-6 font-medium text-white"
                      id="modal-headline"
                    >
                      {details?.title}
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-200">{details?.header}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="text-gray-900 bg-gray-200 px-4 py-1 rounded-md">
                    ${updatedPackagePrice}
                  </p>
                </div>
              </div>
              <div className="mt-3 md:mt-6 text-center tracking-wide font-mono space-y-1">
                <p className="">
                  Вы можете просто отправить BTC на этот адрес:
                </p>
                <p>{address}</p>
                <div className="flex gap-2 justify-center pt-2">
                  <p className="">Количество:</p>
                  <p>{btcRate} BTC</p>
                </div>
              </div>
              <div className="mt-3 md:mt-6">
                <div
                  style={{
                    height: "auto",
                    margin: "0 auto",
                    maxWidth: 150,
                    width: "100%",
                  }}
                  className="border-2"
                >
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={address || ""}
                    viewBox={`0 0 256 256`}
                  />
                </div>
              </div>
            </div>
          </Modal>

          {showNowPayments && (
            <NowPayments
              priceAfterVoucher={priceAfterVoucher}
              details={details}
              onPaymentCreated={(paymentData) => {
                console.log("[PriceCard] Payment created:", paymentData);
                setPaymentDetails(paymentData);
                setIsNowPaymentsModalOpen(true);
                setShowNowPayments(false);
                console.log("[PriceCard] isNowPaymentsModalOpen set to:", true);
                console.log("[PriceCard] showNowPayments set to:", false);
              }}
            />
          )}

          {isNowPaymentsModalOpen && paymentDetails && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-[#26303C] p-6 rounded-lg max-w-lg w-full mx-4">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-medium text-white">
                    Детали платежа
                  </h3>
                  <button
                    onClick={() => {
                      closeNowPaymentsModal();
                      setShowNowPayments(false);
                      setCheckedValue("");
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="space-y-4">
                  <CountdownTimer
                    expiryDate={paymentDetails.expiration_estimate_date}
                  />

                  {/* Payment Status */}
                  <div className="bg-gray-800 p-4 rounded-lg text-center">
                    <p className="text-gray-300 text-sm mb-1">
                      Статус платежа:
                    </p>
                    <p
                      className={`text-lg font-medium ${getStatusColor(
                        paymentDetails.payment_status
                      )}`}
                    >
                      {getStatusMessage(paymentDetails.payment_status)}
                    </p>
                    <p className="text-sm text-gray-400 mt-1">
                      Отправьте{" "}
                      {formatCurrencyName(paymentDetails.pay_currency)} для
                      завершения платежа
                    </p>
                  </div>

                  <div className="flex justify-between items-center bg-gray-700 p-4 rounded-lg">
                    <div>
                      <p className="text-gray-300 text-sm">Сумма к оплате:</p>
                      <p className="text-white font-medium">
                        {paymentDetails.pay_amount}{" "}
                        {paymentDetails.pay_currency.toUpperCase()}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-300 text-sm">Цена:</p>
                      <p className="text-white font-medium">
                        ${paymentDetails.price_amount}{" "}
                        {paymentDetails.price_currency.toUpperCase()}
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-700 p-4 rounded-lg">
                    <p className="text-gray-300 text-sm mb-1">
                      Отправьте платеж на этот адрес:
                    </p>
                    <p className="font-mono text-blue-400 break-all text-sm">
                      {paymentDetails.pay_address}
                    </p>
                  </div>

                  <div className="flex justify-center py-4">
                    {paymentDetails.pay_address && (
                      <QRCode
                        value={paymentDetails.pay_address}
                        size={180}
                        level="H"
                        className="bg-white p-2 rounded-lg"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
